<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <div
              class="row dblock"
              style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);"
            >
              <div class="row">
                <div class="col-md-12">
                  <vs-breadcrumb
                    align="left"
                    :items="
                      [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Advisor/advisordashboard'
                    },
                    {
                      title: 'Update Training',
                      url: '/#/dashboard/Advisor',
                      active: true
                    }
                    
                      ]"
                  ></vs-breadcrumb>

                  <div class="heading mt-3">
                    <h3 class="text-secondary">ADVISOR</h3>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="col-md-12 col-lg-12">
                  <b-card v-if="isForm" style="border: 1px dotted #07a7e14f;">
                    <form @submit.prevent="advisorForm">
                      <div class="form-group">
                        <div class="row">
                          <!-- floating input starts -->
                          <div class="col-sm-12 mb-3">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="updateTraining.title"
                                type="text"
                                disabled
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                ></i>
                              </span>
                              <label class="lbl-label">Training Name</label>
                            </div>
                          </div>
                          <div class="col-sm-12 mb-3">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="updateTraining.project.title"
                                type="text"
                                disabled
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                ></i>
                              </span>
                              <label class="lbl-label">Project Title</label>
                            </div>
                          </div>
                          <div class="col-sm-12 mb-3">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="updateTraining.subprogram.title"
                                type="text"
                                disabled
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                ></i>
                              </span>
                              <label class="lbl-label">Sub Program</label>
                            </div>
                          </div>

                          <div class="col-sm-12 mb-3">
                            <label style="padding-left: 5px;font-size:.85rem;"
                              >Doner Name</label
                            >
                            <selectize
                              id="select-state"
                              v-model="donerSelected"
                              :settings="donersettings"
                            >
                              <option
                                v-for="(item,index) in donernameArr"
                                :key="index"
                                :value="item.id"
                              >
                                {{item.title}}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-sm-12 mb-3">
                            <label style="padding-left: 5px;font-size:.85rem;"
                              >Thematic Area / Outcome</label
                            >
                            <selectize
                              id="select-state"
                              v-model="thematicareaSelected"
                              :settings="thematicareasettings"
                            >
                              <option
                                v-for="(item,index) in valuesArray"
                                :key="index"
                                :value="item.id"
                              >
                                {{item.name}}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-sm-12 mb-4">
                            <label style="padding-left: 5px;font-size:.85rem;">
                              Assign to
                              <small>(Program Officer)</small>
                            </label>
                            <selectize
                              id="select-state"
                              v-model="assignPOSelected"
                              :settings="assignPOsettings"
                            >
                              <option
                                v-for="(item,index) in programOfficerAssign"
                                :key="index"
                                :value="item.id"
                              >
                                {{item.name}}
                              </option>
                            </selectize>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="row">
                          <!-- floating input starts -->
                          <div class="col-sm-6" style="margin-top:10px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="noOfDays"
                                type="text"
                                placeholder=" "
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >event</i
                                >
                              </span>
                              <label class="lbl-label">Number of Days</label>
                            </div>
                          </div>
                          <!-- floating input ends -->
                          <!-- floating input starts -->
                          <div
                            class="col-md-6 col-lg-6"
                            style="margin-top:10px;"
                          >
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model.number="freqLimit"
                                type="number"
                                placeholder=" "
                              />
                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >av_timer</i
                                >
                              </span>
                              <label class="lbl-label">Frequency</label>
                            </div>
                          </div>
                          <!-- floating input ends -->
                          <div
                            v-for="(item,index) in freqLimitArr"
                            :key="index"
                          >
                            <div class="col-sm-6">
                              <label for class="vs-input--label"
                                >Start Date</label
                              >
                              <date-picker
                                v-model="item.startDate"
                                :config="options"
                              ></date-picker>
                            </div>
                            <div class="col-sm-6">
                              <label for class="vs-input--label"
                                >End Date</label
                              >
                              <date-picker
                                v-model="item.endDate"
                                :config="options"
                              ></date-picker>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <!-- add button starts-->
                            <b-button
                              type="submit"
                              class="save-btn"
                              variant="primary"
                              >Add</b-button
                            >
                            <!-- add button ends -->
                          </div>
                        </div>
                      </div>
                    </form>
                  </b-card>
                  <b-card
                    v-if="isEditForm"
                    style="border: 1px dotted #07a7e14f;"
                  >
                    <form @submit.prevent="updateAdvisorForm">
                      <div class="form-group">
                        <div class="row">
                          <!-- floating input starts -->
                          <div class="col-sm-12 mb-3">
                            <div class="floating-label">
                              <input
                                disabled
                                class="floating-input form-control"
                                v-model="updateTraining.title"
                                type="text"
                                placeholder
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                ></i>
                              </span>
                              <label class="lbl-label">Training Name</label>
                            </div>
                          </div>
                          <div class="col-sm-12 mb-3">
                            <div class="floating-label">
                              <input
                                disabled
                                class="floating-input form-control"
                                v-model="updateTraining.project.title"
                                type="text"
                                placeholder
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                ></i>
                              </span>
                              <label class="lbl-label">Project Title</label>
                            </div>
                          </div>
                          <div class="col-sm-12 mb-3">
                            <div class="floating-label">
                              <input
                                disabled
                                class="floating-input form-control"
                                v-model="updateTraining.subprogram.title"
                                type="text"
                                placeholder
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                ></i>
                              </span>
                              <label class="lbl-label">Sub Program</label>
                            </div>
                          </div>

                          <div class="col-sm-12 mb-3">
                            <label
                              style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                            >
                              Donor Name
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <selectize
                              id="select-state"
                              v-model="fundingAgencySelected"
                              :settings="donersettings"
                            >
                              <option
                                v-for="(item,index) in donernameArr"
                                :key="index"
                                :value="item.id"
                              >
                                {{item.title}}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-sm-12 mb-3">
                            <label
                              style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                            >
                              Thematic Area
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <selectize
                              id="select-state"
                              v-model="thematicareaSelectedUpdate"
                              :settings="thematicareasettings"
                            >
                              <option
                                v-for="(item,index) in valuesArray"
                                :key="index"
                                :value="item.id"
                              >
                                {{item.name}}
                              </option>
                            </selectize>
                          </div>
                          <div class="col-sm-12 mb-3">
                            <label style="padding-left: 5px;font-size:.85rem;">
                              Assign to
                              <small>(Program Officer)</small>
                              <span style="color:rgba(255, 0, 0, 0.78);"
                                >*</span
                              >
                            </label>
                            <selectize
                              id="select-state"
                              v-model="officerSelected"
                              :settings="countrySetting"
                              :searchable="true"
                            >
                              <option
                                v-for="(item,index) in programOfficerAssign"
                                :key="index"
                                :value="item.id"
                              >
                                {{item.name}}
                              </option>
                            </selectize>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-6">
                            <span
                              style="color:rgba(255, 0, 0, 0.78);margin-top: -15px;position: absolute;"
                              >*</span
                            >
                            <flat-pickr
                              class="form-control"
                              style="background: #fff"
                              placeholder="Start date Range *"
                              v-model="dateRange"
                              :config="dateOptions"
                            ></flat-pickr>
                          </div>
                          <!-- floating input starts -->
                          <div class="col-sm-6">
                            <div class="floating-label">
                              <input
                                disabled
                                class="floating-input form-control"
                                v-model="noOfDays"
                                type="text"
                                placeholder=" "
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i
                                  class="material-icons"
                                  style="font-size: 20px;"
                                  >event</i
                                >
                              </span>
                              <label class="lbl-label">Number of Days</label>
                            </div>
                            <input type="hidden" v-model="update_training_id" />
                          </div>
                          <!-- floating input ends -->

                          <div class="col-sm-12">
                            <!-- add button starts-->
                            <b-button
                              type="submit"
                              class="save-btn"
                              variant="primary"
                              >Update</b-button
                            >
                            <router-link
                              to="/dashboard/Advisor/advisordashboard"
                            >
                              <b-button
                                type="button"
                                class="save-btn mr-1 text-white"
                                @click="CancelUpdate"
                                variant="warning"
                                >Back</b-button
                              >
                            </router-link>
                            <!-- add button ends -->
                          </div>
                        </div>
                      </div>
                    </form>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Selectize from "vue2-selectize";

import "bootstrap/dist/css/bootstrap.css";
// Import this component
import datePicker from "vue-bootstrap-datetimepicker";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import axios from "axios";

// flatPickr
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data: () => ({
    isSidebar: false,
    updateTraining: [],
    errors: [],
    success: "",

    trainingId: "",
    update_training_id: "",
    freqLimit: "",
    trainingName: "",
    noOfDays: "",
    projectName: "",
    freqLimitArr: [{ startDate: "", endDate: "" }],
    freqUpdateArr: [{ startDate: "", endDate: "" }],
    isForm: true,
    isEditForm: false,
    isFormData: false,
    selected: "",
    donerSelected: [],
    donersettings: {
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    dateRange: [],
    dateOptions: {
      wrap: true,
      weekNumbers: true,
      mode: "range",
      maxDate: new Date().fp_incr(9),
      dateFormat: "d-m-Y"
    },
    valuesArray: [],
    programOfficerAssign: [],
    thematicareaSelected: [],
    thematicareaSelectedUpdate: [],
    thematicareasettings: {
      maxItems: 10,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    assignPOSelected: "",
    assignPOsettings: {
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    }, // https://github.com/selectize/selectize.js/blob/master/docs/usage.md
    contact_person: "",
    contact_number: "",
    isDataEdit: 0,
    contact_email: "",
    address: "",
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    textarea: "",
    counterDanger: false,
    mydate: "",
    startDate: "",
    endDate: "",
    Dates: [{ startDate: "", endDate: "" }],
    colorx: "#1db952",
    trainingCheck: false,
    repeatedCheck: false,
    select1Normal: "",
    select1: 1,
    thematicSelected: [],
    fundingAgencySelected: [],
    officerSelected: "",
    thematicareaArr: [],
    projecttitleArr: [],
    donernameArr: []
  }),
  created() {
    // Set the initial number of items
    //this.totalRows = this.items.length;
    this.trainingId = this.$route.query.trainingId;

    this.isForm = false;
    this.isEditForm = true;
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/training/advisor/" +
          this.$route.query.trainingId +
          "/edit"

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response) {
          this.thematicareaSelectedUpdate = [];
          this.fundingAgencySelected = [];
          this.officerSelected = [];
          // this.freqUpdateArr =[];
          response.data.thematic.forEach(dnr => {
            this.thematicareaSelectedUpdate.push(dnr.id);
          });
          response.data.fundingagency.forEach(dnr => {
            this.fundingAgencySelected.push(dnr.id);
          });
          response.data.officer.forEach(dnr => {
            this.officerSelected.push(dnr.id);
          });
          if (
            response.data.training != "" &&
            response.data.training.TrainingDates != undefined &&
            response.data.training.TrainingDates != ""
          ) {
            JSON.parse(response.data.training.TrainingDates).forEach(
              element => {
                if (
                  element.startDate != undefined &&
                  element.endDate != undefined &&
                  element.endDate != "" &&
                  element.startDate != ""
                ) {
                  this.freqUpdateArr.push({
                    startDate: element.startDate,
                    endDate: element.endDate
                  });
                }
              }
            );
          }

          this.noOfDays = response.data.training.noofdays;
          this.freqLimit = response.data.training.frequency;
        }
      });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/thematics/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.valuesArray = response.data;
      });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/donernames/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.donernameArr = response.data;
      });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/programofficer/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.programOfficerAssign = response.data;
      });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/projects/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.projecttitleArr = response.data;
      });
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/advisor/trainingsingle/get/" +
          this.trainingId

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.updateTraining = response.data;
        this.dateRange =
          response.data.startdate + " to " + response.data.enddate;
      });
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')},
  components: {
    datePicker,
    Selectize,
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
    flatPickr
  },
  methods: {
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    editRecord(id) {
      this.update_training_id = id;
      this.isForm = false;
      this.isEditForm = true;
      this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/training/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if (response) {
            this.thematicareaSelectedUpdate = [];
            this.fundingAgencySelected = [];
            this.officerSelected = [];
            // this.freqUpdateArr =[];
            response.data.thematic.forEach(dnr => {
              this.thematicareaSelectedUpdate.push(dnr.id);
            });
            response.data.fundingagency.forEach(dnr => {
              this.fundingAgencySelected.push(dnr.id);
            });
            response.data.officer.forEach(dnr => {
              this.officerSelected.push(dnr.id);
            });
            this.closeLoading();
            if (
              response.data.training != "" &&
              response.data.training.TrainingDates != undefined &&
              response.data.training.TrainingDates != ""
            ) {
              JSON.parse(response.data.training.TrainingDates).forEach(
                element => {
                  if (
                    element.startDate != undefined &&
                    element.endDate != undefined &&
                    element.endDate != "" &&
                    element.startDate != ""
                  ) {
                    this.freqUpdateArr.push({
                      startDate: element.startDate,
                      endDate: element.endDate
                    });
                  }
                }
              );
            }
            this.noOfDays = response.data.training.noofdays;
            this.freqLimit = response.data.training.frequency;
          }
        });
    },
    CancelUpdate() {
      this.isForm = true;
      this.isEditForm = false;
    },
    showinputvalue: function(event) {
      this.name = event.target.value;
    },
    advisorForm(e) {
      e.preventDefault();

      this.inValid = [];
      if (!this.thematicareaSelected) {
        this.inValid.push("Please select Thematic Area.");
      }
      if (!this.donerSelected) {
        this.inValid.push("Please Select Doner.");
      }
      if (!this.assignPOSelected) {
        this.inValid.push("Please Select Assign To.");
      }
      if (!this.noOfDays) {
        this.inValid.push("Please enter number of days.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
      let self = this;
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") + "/advisor/update/training",
            {
              user_id: JSON.parse(localStorage.getItem("currentUser")).id,
              doner: this.donerSelected,
              trainingId: this.trainingId,
              thematic: this.thematicareaSelected,
              assgin: this.assignPOSelected,
              noofdays: this.noOfDays,
              frequence: this.freqLimit,
              // Dates: this.freqLimitArr,
              startDate: this.startDate,
              endDate: this.endDate,
              frequency: this.frequency
            }
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.$router.push({ name: "AdvisorDashboard" });
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateAdvisorForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (
        this.thematicareaSelectedUpdate == "" ||
        this.thematicareaSelectedUpdate.length == 0
      ) {
        this.inValid.push("Please select Thematic Area.");
      }
      if (
        this.fundingAgencySelected == "" ||
        this.fundingAgencySelected.length == 0
      ) {
        this.inValid.push("Please Select Donor.");
      }
      if (this.officerSelected == "" || this.officerSelected.length == 0) {
        this.inValid.push("Please Select Assign To.");
      }
      if (this.noOfDays == "" || this.noOfDays.length == 0) {
        this.inValid.push("Please enter number of days.");
      }

      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      let self = this;
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") + "/advisor/update/training",
            {
              user_id: JSON.parse(localStorage.getItem("currentUser")).id,
              doner: JSON.stringify(this.fundingAgencySelected),
              trainingId: this.trainingId,
              thematic: JSON.stringify(this.thematicareaSelectedUpdate),
              assgin: this.officerSelected,
              noofdays: this.noOfDays,
              frequence: this.freqLimit,
              startDate: this.startDate,
              endDate: this.endDate
              // Dates: JSON.stringify(this.freqUpdateArr),
              // frequency: this.frequency
            }
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.$router.push({ name: "AdvisorDashboard" });
            } else {
              self.toastError("Something went wrong. Try again please!");
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    }
  },
  watch: {
    dateRange(date) {
      this.startDate = date.split(" to")[0];
      this.endDate = date.split("to ")[1];
      this.isDataEdit++;
      if (this.isDataEdit > 1) {
        let daysLengthTotal;
        this.startDate = date.split(" to")[0];
        this.endDate = date.split("to ")[1];
        if (date.includes("to")) {
          let daysInRange = document.getElementsByClassName("inRange");
          if (this.startDate.split("-")[1] == this.endDate.split("-")[1]) {
            daysLengthTotal = daysInRange.length + 2;
          } else {
            daysLengthTotal = daysInRange.length + 1;
          }
          this.noOfDays = daysLengthTotal;
        }
      }
    }
    // freqLimit(val) {
    //   this.freqLimitArr = [];
    //   for (var i = 0; i < val; i++) {
    //     this.freqLimitArr.push({
    //       startDate: "",
    //       endDate: ""
    //     });
    //   }
    // },
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #ffffff;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

.display-table ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.display-table li {
  float: left;
  padding: 5px 5px;
}

.display-table li a {
  cursor: inherit;
  font-size: 14px;
  display: block;
  color: #747679;
  text-align: center;
  padding: 5px;
  text-decoration: none;
  background-color: #f1f1f1;
}
.tbl-head th {
  font-weight: 400 !important;
  color: rgba(7, 167, 225, 0.61);
}
.display-table {
  /* margin-bottom: 0px !important; */
  color: #8e8e8e;
}
.display-table th,
.display-table td {
  padding: 5px 10px !important;
  /* border: 1px dotted #07a7e14f; */
}
</style>
